// import { useEffect, useState } from "react";
// import { doc, onSnapshot } from "firebase/firestore";
// import { db } from "../firebase";

// export function useContentDoc(collection, id) {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const ref = doc(db, collection, id);
//     const unsub = onSnapshot(
//       ref,
//       (snap) => {
//         setData(snap.data() || null);
//         setLoading(false);
//       },
//       (err) => {
//         setError(err);
//         setLoading(false);
//       }
//     );
//     return unsub;
//   }, [collection, id]);

//   return { data, loading, error };
// }
// src/hooks/useContentDoc.ts
// src/hooks/useContentDoc.js
import { useEffect, useState } from "react";
import { doc, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export function useContentDocBase(collectionName, docId, options) {
  const opts = options || {};
  const fallback = Object.prototype.hasOwnProperty.call(opts, "fallback")
    ? opts.fallback
    : null;
  const once = !!opts.once;

  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // базовий лог, щоб перевірити, що хук стартує
    // (побачиш одразу при першому рендері)
    // eslint-disable-next-line no-console
    console.log("[useContentDoc] mount", { collectionName, docId, once });

    if (!collectionName || !docId) {
      setLoading(false);
      setError(new Error("Invalid path for useContentDoc"));
      return;
    }

    const ref = doc(db, collectionName, docId);

    if (once) {
      let cancelled = false;
      getDoc(ref)
        .then((snap) => {
          if (cancelled) return;
          setData(snap.exists() ? snap.data() : fallback);
          setLoading(false);
          // eslint-disable-next-line no-console
          console.log("[useContentDoc] getDoc OK");
        })
        .catch((e) => {
          if (cancelled) return;
          setError(e);
          setLoading(false);
          // eslint-disable-next-line no-console
          console.log("[useContentDoc] getDoc ERROR", e);
        });
      return () => {
        cancelled = true;
      };
    }

    const unsub = onSnapshot(
      ref,
      (snap) => {
        setData(snap.exists() ? snap.data() : fallback);
        setLoading(false);
        // eslint-disable-next-line no-console
        console.log(
          "[useContentDoc] onSnapshot OK (exists:",
          snap.exists(),
          ")"
        );
      },
      (e) => {
        setError(e);
        setLoading(false);
        // eslint-disable-next-line no-console
        console.log("[useContentDoc] onSnapshot ERROR", e);
      }
    );

    return () => unsub();
  }, [collectionName, docId, once]);

  return { data, loading, error };
}

// робимо дефолт-експорт з тим самим ім’ям, яке ти імпортуєш у компоненті
export default function useContentDoc(collectionName, docId, options) {
  return useContentDocBase(collectionName, docId, options);
}
